import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import Icon from 'components/Icon';

const Container = styled.div`
	position: relative;
	height: 60px;
	min-width: 100px;
	font-size: 14px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	justify-items: center;
	align-items: center;
	color: #787878;
	cursor: pointer;

	.icon {
		margin: 0 0 8px;

		svg, path {
			fill: #D2D9E5;
		}
	}

	@media (max-width: 1000px) {
		min-width: 0;
	}

	&:hover {
		color: #4A90E2;

		&:before {
			content: "";
			position: absolute;
			bottom: 0px;
			right: 0px;
			width: 100%;
			height: 2px;
			background-color: #4A90E2;
		}

		.icon {
			svg, path {
				fill: #4A90E2;
			}
		}
	}
`;

const ChangeLanguage = props => {
	const { t, i18n, history } = props;

	const changeLanguage = language => {
		i18n.changeLanguage(language);

		const path = window.location.pathname.split('/');
		path[1] = language;

		history.push(path.join('/'));
	};

	return (
		<Container onClick={() => changeLanguage(t('app/Other language'))}>
			<Icon icon="globe" /> {t('app/Other language name')}
		</Container>
	)
}

ChangeLanguage.propTypes = {
	history: PropTypes.any,
	onClickHandler: PropTypes.func,
	t: PropTypes.any,
	i18n: PropTypes.any,
}

export default translate('translations')(ChangeLanguage);
